<div class="branded-asset-cover">
	<div class="middle">
		<div class="floating-entry">
			<div class="branded-asset-logo"></div>
		</div>
		<div class="floating-entry">
			<div class="input-bounder">
				<form *ngIf="!success" (ngSubmit)="Reset()">
					<div [hidden]="showMfa">
						<div class="form-group">
							<label for="password">Password</label>
							<input [(ngModel)]="password" name="password" type="password" id="password" autocomplete="new-password" class="form-control">
						</div>
						<div class="form-group">
							<label for="password2">Confirm Password</label>
							<input [(ngModel)]="password2" name="password2" type="password" id="password2" autocomplete="new-password" class="form-control">
						</div>
					</div>
					<div *ngIf="showMfa">
						<div class="form-group mb-5">
							<label for="mfa">MFA Code</label>
							<input [(ngModel)]="mfaCode" name="mfa_code" type="text" id="mfa" autocomplete="one-time-code" class="form-control">
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-success">Reset Password</button>
					</div>
				</form>
				<div *ngIf="success">
					<div>Your password has been reset!</div>
				</div>
				<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
				<div class="forgot-link mt-4"><a [routerLink]="['/login']">Return to login</a></div>
			</div>
		</div>
	</div>
</div>